import { render, staticRenderFns } from "./parks.vue?vue&type=template&id=35638f53&"
import script from "./parks.vue?vue&type=script&lang=js&"
export * from "./parks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports